

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-about-variant4-2shmJCa)"}, ["\n", h('path', {"d":"M43.609 43.6106C51.91 35.3096 51.91 21.8511 43.609 13.5501C35.308 5.24912 21.8495 5.24912 13.5485 13.5501C5.24758 21.8511 5.24758 35.3096 13.5485 43.6106C21.8495 51.9115 35.308 51.9115 43.609 43.6106Z","stroke":"current","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n", h('path', {"d":"M43.6091 43.6104L56.6771 56.6756","stroke":"current","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-about-variant4-2shmJCa"}, ["\n", h('rect', {"width":"64","height":"64","fill":"white"}, []), "\n"]), "\n"]), "\n"]);
};

        